import axios from "axios";
import logger from "../logService";
import {toast} from "react-toastify";

// axios.interceptors.response.use(
//   function(response) {
//     console.log("axios.intercepts.respone.use() response:");
//     // Any status code that lie within the range of 2xx cause this function to trigger
//     // Do something with response data

//     // try {
//     //   if (
//     //     response &&
//     //     response.data &&
//     //     response.data.toString().indexOf("/login/authenticate") >= 0
//     //   ) {
//     //     login();
//     //   }
//     // } catch (e) {}
//     return response;
//   },
//   function(error) {
//     console.log("axios.intercepts.respone.use() error:");
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     // Do something with response error
//     return Promise.reject(error);
//   }
// );

// export function login() {
//   if (window.location.host === "localhost:3000") {
//     window.location.assign("http://localhost:8080/login/auth");
//   } else if (window.location.host === "localhost:3001") {
//     window.location.assign("http://localhost:8080/login/auth");
//   } else {
//     const baseApp = new BaseApp();
//     baseApp.logProperties();
//   }
// }

axios.interceptors.response.use(null, error => {
    // console.log("axios.intercepts.respone.use() null,error:");
    const expectedError =
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500;

    if (error && error.response && error.response.status) {
        switch (error.response.status) {
            case 400:
                toast.error("Anmeldeversuch fehlgeschlagen");
                break;
            case 401:
                toast.error("Sie sind nicht angemeldet");
                // const abc = Promise.reject(new Error({ status: 401 }));
                // console.log("new Error(): abc=", abc);
                return {
                    status: 401,
                    data: {username: "", access_token: "", refresh_token: ""}
                };
            case 500:
                toast.error("Der Benutzer hat keine Rolle");
                return {
                    status: 500,
                    data: {}
                };
            default:
                toast.error("Verbindungsfehler: status=" + error.response.status);
        }
    }

    if (!expectedError) {
        logger.log(error);
        toast.error(
            "An unexpected error occurrred. (status=" +
            (error && error.response ? error.response.status : "unknown") +
            ")"
        );
    }

    // return Promise.reject(error);
    return error;
});

export function getApiUrl() {
    let apiUrl = "";
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
        // Development
        apiUrl = "http://localhost:8080";
        // apiUrl = "https://beta.clockwork.at/clockworkService";
        // apiUrl = "http://localhost/clockwork";
    } else {
        // Production
        // console.log("window.location", window.location)
        apiUrl = window.location.origin + "/clockworkService";

        // Bundesgärten
        // apiUrl = "http://s04.bg.bundesgaerten.at:8080/sorex";

        // apiUrl = window.location.origin + "/tortec";

        // apiUrl = window.location.origin + "/clockwork"

        // apiUrl = "http://localhost/clockwork"
        // apiUrl = window.location.origin + "/clockwork";

    }
    // console.log("window.location=", window.location);
    console.log("httpService.getApiUrl(): apiUrl=", apiUrl);

    return apiUrl;
}

export function getWithJWT(credentials, url) {
    const header = {
        Authorization: "Bearer " + credentials.tokens.access_token,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
    };
    axios.defaults.headers.common = header;

    const result = axios.get(url);
    return result;
}

export function postWithJWT(credentials, url, object) {
    const header = {
        Authorization: "Bearer " + credentials.tokens.access_token,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
    };
    axios.defaults.headers.common = header;

    const result = axios.post(url, object);
    return result;
}

export function putWithJWT(credentials, url, object) {
    const header = {
        Authorization: "Bearer " + credentials.tokens.access_token,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
    };
    axios.defaults.headers.common = header;

    const result = axios.put(url, object);
    return result;
}

export function deleteWithJWT(credentials, url) {
    const header = {
        Authorization: "Bearer " + credentials.tokens.access_token,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
    };
    axios.defaults.headers.common = header;

    const result = axios.delete(url);
    return result;
}

export default {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete
};
